/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React from "react";
import { ACCESSIBILITY_FORM_NODE_TITLE } from "constants/enums";

const getSelectedValuesText = (value, exportValues) => {
  let stringToBeRead = value;
  let numOfOptions = exportValues.length;
  let index = exportValues.indexOf(value);
  if (index !== -1) {
    stringToBeRead += ` ${index + 1} of ${numOfOptions} selected`;
  } else {
    stringToBeRead += ` selected`;
  }
  return stringToBeRead;
};

export const AccessibleComboBoxNode = ({ annotInfo: { tooltip, enumNames, value }, style }) => (
  <p style={style}>
    {`${tooltip}, ${ACCESSIBILITY_FORM_NODE_TITLE.READONLY} ${ACCESSIBILITY_FORM_NODE_TITLE.COMBO_BOX}, ${
      value ? getSelectedValuesText(value, enumNames) : ACCESSIBILITY_FORM_NODE_TITLE.EMPTY_VALUE
    }`}
  </p>
);
